module.exports = __webpack_public_path__ + "img/313x442px.18339aae.jpg";